<template>
  <v-container style="max-width: 1264px;">
    <v-tabs class="account-page-tabs mb-6" v-if="$vuetify.breakpoint.mdAndUp" :grow="$vuetify.breakpoint.xsOnly">
      <v-tab to="/account/profile">
        <v-icon left>mdi-account</v-icon>
        {{ $t('my-profile') }}
      </v-tab>
      <v-tab to="/account/preferences">
        <v-icon left>mdi-cog</v-icon>
        {{ $t('preferences') }}
      </v-tab>
      <v-tab to="/account/subscriptions">
        <v-icon left>mdi-tune</v-icon>
        {{ $t('subscriptions') }}
      </v-tab>
      <v-tab to="/account/api">
        <v-icon left>mdi-code-tags</v-icon>
        {{ $t('api') }}
      </v-tab>
      <v-tab to="/account/billing">
        <v-icon left>mdi-credit-card-clock-outline</v-icon>
        {{ $t('billing') }}
      </v-tab>
    </v-tabs>

    <router-view></router-view>
  </v-container>
</template>

<script>
export default {
  name: 'AccountPage'
}
</script>

<style>
.account-page-tabs .v-tab--active .v-icon {
  color: #1976d2;
}
</style>

<i18n>
{
	"en": {
		"api": "Api",
		"billing": "Billing",
		"my-profile": "My Profile",
		"preferences": "Preferences",
		"subscriptions": "Subscriptions"
	},
	"es": {
		"api": "Api",
		"billing": "Facturación",
		"my-profile": "Mi perfil",
		"preferences": "Preferencias",
		"subscriptions": "Suscripciones"
	},
	"fr": {
		"api": "Api",
		"billing": "Facturation",
		"my-profile": "Mon Profil",
		"preferences": "Préférences",
		"subscriptions": "Abonnements"
	},
	"it": {
		"api": "Api",
		"billing": "Fatturazione",
		"my-profile": "Il mio profilo",
		"preferences": "Preferenze",
		"subscriptions": "Abbonamenti"
	},
	"pt": {
		"api": "Api",
		"billing": "Faturação",
		"my-profile": "O meu perfil",
		"preferences": "Preferências",
		"subscriptions": "Subscrições"
	},
	"pl": {
		"api": "Api",
		"billing": "Faktury",
		"my-profile": "Mój profil",
		"preferences": "Preferencje",
		"subscriptions": "Subskrypcje"
	}
}
</i18n>